import React from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

import Text from './Text';
import { Overline } from '@components/basic/layouts/Section';

import theme from '../../styles/theme';

const {
	font,
	colors,
	breakPoints: { screenQuery, mobileFirstScreenQuery },
} = theme;

const TestiomnialWrapper = styled.div`
	${props =>
		props.sideImage
			? `
				display: flex;
				flex-direction: row;

				${screenQuery.mobile} {
					flex-direction: column;
				}
			`
			: ``}

	${props =>
		props.italicQuote
			? `
				.main-quote {
					font-style: italic;
				}
			`
			: ``}

	> p {
		padding: 30px 0;
		font-style: italic;
	}
	.home-testimonial-bio {
		display: flex;
		align-items: center;

		img {
			max-width: 100px;
			margin-right: 24px;
			border-radius: ${props => (props.roundedPhoto ? '50%' : '')};
		}

		.gatsby-image-wrapper {
			margin-right: 24px;
		}
	}
	.home-testimonial-photo {
		min-width: 260px;
		max-width: 270px;

		img {
			width: 100%;
		}
	}
`;

const BioTitle = styled.div`
	${props =>
		props.sideImage
			? `
					display: flex;
					flex-direction: row;
					align-items: center;
					gap: 8px;
					margin-top: 16px;

					.bio-name {
						font-weight: 700;
						font-size: 13px;
						line-height: 18px;
						letter-spacing: 0.2em;
						text-transform: uppercase;
						color: #333333;
					}
					.bio-title, .bio-company {
						font-weight: 600;
						font-size: 14px;
						line-height: 20px;
						letter-spacing: 0.01em;
						color: #333333;
					}
					${screenQuery.mobile} {
						flex-direction: column;
						align-items: flex-start;
					}
				`
			: ``}
	> div {
		display: flex;
		flex-direction: row;
		algign-items: center;
		gap: 4px;

		${screenQuery.mobile} {
			flex-direction: column;
		}
	}
	p {
		color: ${colors.black};
	}
`;

const BasicTestimonial = ({
	sideImage,
	overline,
	quote,
	bioPhoto,
	bioName,
	bioTitle,
	bioCompany,
	inlineQuotes,
	italicQuote,
	roundedPhoto,
	className,
	...props
}) => {
	return (
		<TestiomnialWrapper
			className={className}
			italicQuote={italicQuote}
			sideImage={sideImage}
			roundedPhoto={roundedPhoto}
			{...props}
		>
			{sideImage && (
				<div className="home-testimonial-photo">
					{bioPhoto && bioPhoto.gatsbyImageData ? (
						<GatsbyImage
							image={bioPhoto.gatsbyImageData}
							alt={`Photo of ${bioName}`}
						/>
					) : (
						<img src={bioPhoto} alt={`Photo of ${bioName}`} />
					)}
				</div>
			)}
			<div>
				{overline && <Overline className="overline">{overline}</Overline>}
				<Text component="b2" className="main-quote">
					{inlineQuotes ? `"${quote}"` : quote}
				</Text>
				<div className="home-testimonial-bio">
					{!sideImage &&
						bioPhoto &&
						(bioPhoto.gatsbyImageData ? (
							<GatsbyImage
								image={bioPhoto.gatsbyImageData}
								alt={`Photo of ${bioName}`}
							/>
						) : (
							<img src={bioPhoto} alt={`Photo of ${bioName}`} />
						))}
					<BioTitle sideImage={sideImage}>
						<Text
							component="b2"
							bold
							style={{ color: colors.black }}
							className="bio-name"
						>
							{bioName}
						</Text>
						<div>
							<Text
								component="b3"
								style={{ color: colors.black }}
								className="bio-title"
							>
								{bioTitle}
								{bioCompany && <span>, </span>}
							</Text>
							{bioCompany && (
								<Text
									component="b3"
									style={{ color: colors.black }}
									className="bio-company"
								>
									{bioCompany}
								</Text>
							)}
						</div>
					</BioTitle>
				</div>
			</div>
		</TestiomnialWrapper>
	);
};

export default BasicTestimonial;
